import React, { useEffect, useState } from "react";

import { useUserContext, useUserDispatchContext } from "../context/User";
import { UserPageType } from "../types/user";
import SideBar from "./SideBar";
import SideBarContent from "./SideBarContent";
import UserPageDogEdit from "./UserPageDogEdit";
import UserPageDogs from "./UserPageDogs";
import UserPageOverview from "./UserPageOverview";

export default function UserPage() {
  const [showSidebar, setShowSidebar] = useState(false);
  const { user } = useUserContext();
  const userDispatch = useUserDispatchContext();

  useEffect(() => {
    setShowSidebar(!!user.page);
  }, [user.page]);

  const onCloseHandle = () => {
    userDispatch({
      type: "set-page",
      payload: { page: null, pageParams: undefined },
    });
    setShowSidebar(false);
  };

  const renderHeader = () => {
    const menu: { title: string; id: UserPageType }[] = [
      { title: "Overview", id: "overview" },
      { title: "Our dogs", id: "our-dogs" },
      { title: "Add dog", id: "add-dog", pageParams: undefined },
    ];
    return (
      <div className="flex flex-row gap-10">
        {menu.map((item) => {
          const isActive = user.page === item.id;
          return (
            <div
              className={`cursor-pointer border-b-[2px] border-white pb-6 pt-8 hover:border-black ${
                isActive || (item.id === "our-dogs" && user.page === "edit-dog")
                  ? "!border-black"
                  : "!text-[#838383]"
              }`}
              key={item.id}
              onClick={() => {
                if (isActive) {
                  return;
                }
                userDispatch({
                  type: "set-page",
                  payload: { page: item.id, pageParams: item.pageParams },
                });
              }}
            >
              {item.title}
            </div>
          );
        })}
      </div>
    );
  };

  const renderPage = () => {
    let page = <SideBarContent>User page</SideBarContent>;

    if (user.page === "overview") {
      page = <UserPageOverview onCloseHandle={onCloseHandle} />;
    }

    if (user.page === "our-dogs") {
      page = <UserPageDogs />;
    }

    if (user.page === "add-dog") {
      page = <UserPageDogEdit />;
    }

    if (user.page === "edit-dog") {
      page = <UserPageDogEdit />;
    }

    return (
      <SideBar show={showSidebar} onClose={onCloseHandle} title={renderHeader()} topOffset={62}>
        {page}
      </SideBar>
    );
  };

  return renderPage();
}
